import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/calculus.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>Journaux de Trévoux</var> (1701)<br />
        pp 270-272<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: end of September 1701<br /><br />
        Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (248k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Mr Leibniz's Memoir concerning His View on the Differential Calculus</title>
            <meta name="description" content="An English translation of MR. LEIBNIZ'S MEMOIR CONCERNING HIS VIEW ON THE DIFFERENTIAL CALCULUS, from end of September 1701" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>MR. LEIBNIZ'S MEMOIR CONCERNING HIS VIEW ON THE DIFFERENTIAL CALCULUS</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
		        <small>This short article is an extract from Leibniz's letter to François Pinsson from the end of September 1701,<a name="1" href="#note1"><sup>1</sup></a>  and was published in the November/December issue of the <var>Mémoires pour l'histoire des sciences et des beaux arts</var> (known more familiarly as the <var>Journaux de Trévoux</var>), of which Pinsson was the editor.</small>
<br /><br />

[<b>JT 270</b>]
<br /><br />
<center>Mr. Leibniz's Memoir concerning His View on the Differential Calculus</center><br /><br />

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;One of the issues of the <var>Journaux de Trévoux</var> contains a method of Mr. Jacques Bernoulli and includes some reflections on the calculus of differences, in which I have played a significant part.<a name="2" href="#note2"><sup>2</sup></a> The author of these reflections seems to find the path through the infinite and the infinite of the infinite not sufficiently certain and too distant from the method of the ancients. But he will kindly consider that if the discoveries are significant, the novelty of the method rather enhances its beauty. As for the certainty of the path, the book by Mr. Marquis de l'Hôpital will be able to provide him with reassurance.<a name="3" href="#note3"><sup>3</sup></a> I would even add to what that illustrious mathematician has said: one does not need to take the infinite literally here, but only in the way that, in optics, we say that the rays of the sun come from a point infinitely far away and are thus [<b>JT 271</b>] considered parallel. And when there are several degrees of infinity or infinitely small, it is as if the globe of the earth is considered a point in relation to the distance of the fixed stars, and a ball we handle is again a point in comparison to the semi-diameter of the globe of the earth. Thus, the distance to the fixed stars is an infinitely infinite, or infinite of the infinite, in relation to the diameter of the ball. For instead of the infinite or the infinitely small, we take quantities as large and as small as necessary so that the error is smaller than any given error. In this way, we differ from Archimedes' style only in the expressions, which are more direct in our method and more in keeping with the art of discovery.<br />
<br />
[The editor then added a postscript:]<br /><br />

Some geometers, who have carefully examined the analysis of infinitesimals by the Marquis de l'Hôpital, and who even profess to follow his method, say that one must take infinity literally there, and not as Mr. Leibniz explains it here. It is in [<b>JT 272</b>] relation to their opinion that this was mentioned in the <var>Memoirs</var> of May and June.   
                <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />
                        NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> See A I 20, 492-494 for the complete letter.<br />
                        <a name="note2" href="#2">2.</a> That is, Thomas Gouye, “Nouvelle methode pour déterminer aisément les rayons de la developpée dans toute sorte de courbe algebraique”, <var>Mémoires pour l'histoire des sciences et des beaux arts</var> (May/June 1701), 223–234.<br />
                        <a name="note3" href="#3">3.</a> That is, Marquis de l'Hôpital, <var>Analyse des infiniment petits, pour l'intelligence des lignes courbes</var> (Paris: L'imprimerie royale, 1696).
                <br /><br /><br />
                        &#169; Lloyd Strickland 2024
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
